import { createContext, useContext } from 'react';

import type { UserContext } from '../api/types';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated' | 'error';

export interface AuthContextValue {
  status: AuthStatus;
  me: UserContext | null;
  error: unknown;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  retry: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}

// useMe liefert den Benutzerkontext innerhalb geschützter Routen (RequireAuth).
export function useMe(): UserContext {
  const { me } = useAuth();
  if (!me) throw new Error('useMe requires an authenticated user');
  return me;
}
